import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";
import {ActiveEventIds} from "../../utils/searchFixtures";

export const getActiveEventIds = (state: ReducerFromState<MonitorReducer>): ActiveEventIds =>
    state.monitor.activeEventIds;
